import React from "react";
import { Routes, Route } from "react-router-dom";

/* ================= USER PAGES ================= */
import Home from "./screens/user/Home/Home";
import DonationsListing from "./screens/user/listing/DonationsListing";
import Contact from "./screens/user/contact/Contact";
import About from "./screens/user/about/About";
import DonorsLogin from "./screens/user/donorlogin/DonorsLogin";
import ReceiverLogin from "./screens/user/receiverlogin/ReceiverLogin";

/* ================= DONOR DASHBOARD ================= */
import DonorSideBar from "./screens/donordashboard/DonorSideBar";
import DonorTopBar from "./screens/donordashboard/DonorTopBar";
import DonorDashboard from "./screens/donordashboard/DonorDashboard";
import DonationHistory from "./screens/donordashboard/DonationHistory";
import FindCenters from "./screens/donordashboard/FindCenters";
import MyProfile from "./screens/donordashboard/MyProfile";
import RewardsAndBadges from "./screens/donordashboard/RewardsAndBadges";
import DonateFood from "./screens/donordashboard/donatenow/DonateFood";
import MedicineDonate from "./screens/donordashboard/donatenow/MedicineDonate";
import DonateBlood from "./screens/donordashboard/donatenow/DonateBlood";

/* ================= RECEIVER DASHBOARD ================= */
import ReceiverDashboard from "./screens/receiverdashboard/ReceiverDashBoard";
import ReceiverMasterLayout from "./components/layout/ReceiverMasterLayout";
import FoodDonation from "./screens/receiverdashboard/FoodDonation";
import BloodDonation from "./screens/receiverdashboard/BloodDonation";
import MedicineDonation from "./screens/receiverdashboard/MedicineDonation";
import MyListings from "./screens/receiverdashboard/MyListings";
import ReceiverNotification from "./screens/receiverdashboard/ReceiverNotification";
import ReceiverSettings from "./screens/receiverdashboard/setting/ReceiverSettings";


/* ================= NGO DASHBOARD ================= */
import Ngodashboard from "./screens/ngodashboard/Ngodashboard";
import DonorManagement from "./screens/ngodashboard/DonorManagement";
import NgoTopBar from "./components/ngodashboard/NgoTopBar"
import NgoSettings from "./screens/ngodashboard/NgoSettings";
import BecomeAdonor from "./screens/ngodashboard/BecomeAdonor";
import NgoNotification from "./screens/ngodashboard/NgoNotification";
/* ================= COMMON ================= */
import MasterLayout from "./components/layout/MasterLayout";
import NGOMasterLayout from "./components/layout/NGOMasterLayout";



import Ngosidebar from "./components/ngodashboard/Ngosidebar";
import ReceiverTopbar from "./screens/receiverdashboard/ReceiverTopBar";
import ReceiverSideBar from "./components/receiverdashboard/ReceiverSideBar";
import Ngomessage from "./screens/ngodashboard/Ngomessage";
import NgoLogin from "./screens/user/ngologin/Ngologin";
import CreateRequest from "./screens/receiverdashboard/CreateRequest";
import DonateRequest from "./screens/donordashboard/DonateRequest";
import PayoutManagement from "./screens/donordashboard/Payoutmanagement";
import HelpSupport from "./screens/donordashboard/Helpsupport";
import ReceiverSupport from "./screens/receiverdashboard/Receiversupport";
import LevelBadgeManagement from "./screens/ngodashboard/LevelBadgeManagement";
import Notification from "./screens/donordashboard/Notification";



function App() {


  return (
    <Routes>

      {/* ========== USER ROUTES ========== */}
      <Route path="/" element={<Home />} />
      <Route path="/listings" element={<DonationsListing />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/donor" element={<DonorsLogin />} />
      <Route path="/receiver" element={<ReceiverLogin />} />
      <Route path="/join-ngo" element={<NgoLogin />} />

      {/* ========== DONOR DASHBOARD ========== */}
      <Route path="/donor/sidebar" element={<DonorSideBar />} />
      <Route path="/donor/topbar" element={<DonorTopBar />} />
      <Route path="/donor/dashboard" element={<DonorDashboard />} />
      <Route path="/donor/donation-history" element={<DonationHistory />} />
      <Route path="/donor/centers" element={<FindCenters />} />
      <Route path="/donor/my-profile" element={<MyProfile />} />
      <Route path="/donor/rewards-badges" element={<RewardsAndBadges />} />
      <Route path="/donor/donate-food" element={<DonateFood />} />
      <Route path="/donor/donate-medicine" element={<MedicineDonate />} /> 
      <Route path="/donor/donate-blood" element={<DonateBlood />} />
       {/* <Route path="/donor/donate-now" element={<DonateForm />} /> */}
       <Route path="/donor/donate-request" element={<DonateRequest/>} />
       <Route path="/donor/payout-NGO" element={<PayoutManagement/>} />
       <Route path="/donor/help&support" element={<HelpSupport/>} />
       <Route path="/donor/notification" element={<Notification/>} />

      {/* -------- RECEIVER DASHBOARD -------- */}
      <Route path="/receiver/layout" element={<ReceiverMasterLayout />} />
      <Route path="/receiver/sidebar" element={<ReceiverSideBar />} />
      <Route path="/receiver/topbar" element={<ReceiverTopbar />} />
      <Route path="/receiver/dashboard" element={<ReceiverDashboard />} />
      <Route path="/receiver/food-donation" element={<FoodDonation />} />
      <Route path="/receiver/blood-donation" element={<BloodDonation />} />
      <Route path="/receiver/medicine-donation" element={<MedicineDonation />} />
      <Route path="/receiver/mylistings" element={<MyListings />} />
      <Route path="/receiver/help-support" element={< ReceiverSupport/>} />
      
      <Route path="/receiver/notification" element={<ReceiverNotification />} />
      <Route path="/receiver/settings" element={<ReceiverSettings />} />
        <Route path="/receiver/create-request" element={<CreateRequest/>} />
      {/* ========== NGO DASHBOARD ========== */}
        <Route path="/ngo/sidebar" element={<Ngosidebar />} />
        <Route path="/ngo/withdrawal-management" element={<DonorManagement />} />
        <Route path="/ngo/notifications" element={<NgoNotification/>} />
        <Route path="/ngo/settings" element={<NgoSettings />} />
        <Route path="/ngo/dashboard" element={<Ngodashboard />} />
        <Route path="/Ngo/TopBar" element={<NgoTopBar />} />
        <Route path="/ngo/messages" element={<Ngomessage />} />
        
         <Route path="/ngo/level-badge" element={<LevelBadgeManagement/>}/>



     
       {/* ========== COMMON ========== */}
        <Route path="/layout" element={<MasterLayout />} />
        <Route path="/ngolayout" element={<NGOMasterLayout/>} />
        <Route path="/ngo" element={<NGOMasterLayout />}/>
        <Route path="*" element={<h1>PAGE NOT FOUND </h1>}/>

    </Routes>
  );
}
export default App;


